import { Modal } from './modal'

export class Form {
  constructor(form) {
    this.form = form
    this.track = this.form.getAttribute('data-track')
    this.submitWrapper = this.form.querySelector('.form__submit')
    this.submitButton = this.form.querySelector('[type=submit]')
    this.fetchUrl = this.form.getAttribute('action')
    this.errorMessage = null
    this.handleSubmit = this.handleSubmit.bind(this)

    this.form.addEventListener('submit', this.handleSubmit)
    this.init()
  }

  disableForm() {
    this.submitButton.setAttribute('disabled', 'disabled')
    this.form.setAttribute('disabled', 'disabled')
  }

  enableForm() {
    this.submitButton.removeAttribute('disabled')
    this.form.removeAttribute('disabled')
  }

  clearMessage() {
    if (this.errorMessage) {
      this.form.removeChild(this.errorMessage)
      this.errorMessage = null
    }
  }

  showMessage(message, error = false) {
    const cssClasses = ['form__helper', 'notice']
    if (error) {
      cssClasses.push('error')
      cssClasses.push('form__helper--error')
    } else {
      cssClasses.push('updated')
    }

    this.errorMessage = document.createElement('div')
    this.errorMessage.className = cssClasses.join(' ')
    this.errorMessage.innerHTML = `<p>${message}</p>`

    this.form.insertBefore(this.errorMessage, this.submitWrapper)
  }

  success(data) {
    const { message = '', redirect = '', reset = false } = data

    const files = this.form.querySelectorAll('[type="file"]')
    Array.from(files).forEach(fileInput => {
      fileInput.value = ''
    })

    document.dispatchEvent(new CustomEvent('form-success'))

    if (message) {
      const modalEl = document.createElement('div')
      modalEl.className = 'modal modal--thank-you'
      modalEl.innerHTML = `
        <div class="modal__dialog bg-white">
          <button type="button" class="modal__close">
            <svg class="icon" width="25" height="25" fill="#000">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#times"></use>
            </svg>
          </button>
          <div class="modal__body">
            <div class="modal__message">
              <div class="modal__message__headline align-center headline headline--lg text-black">
                ${message}
              </div>
            </div>
          </div>
        </div>
      `
      document.body.appendChild(modalEl)
      const modal = new Modal(modalEl, true)
      modal.open({ target: this.submitButton })
    }

    if (reset) {
      this.form.reset()
    }

    if (redirect) {
      window.location.href = redirect
    }
  }

  error(data) {
    const { message } = data
    this.showMessage(`Error: ${message}`, true)
    document.dispatchEvent(new CustomEvent('form-error'))
  }

  async handleSubmit(e) {
    e.preventDefault()

    if (!this.fetchUrl) {
      throw new Error('Form - No action parameter specified')
    }

    // Track form submission
    if (this.track && window.dataLayer) {
      window.dataLayer.push({
        event: `${this.track}-submit`,
      })
    }

    const formData = new FormData(this.form)
    const { sitekey = '', recaptcha = '' } = window.sapiens

    if (sitekey && window.grecaptcha && recaptcha === 'v3') {
      await window.grecaptcha.execute(sitekey, { action: 'submit' }).then(token => {
        formData.append('g-recaptcha-response', token)
      })
    }

    this.clearMessage()
    this.disableForm()

    const response = await fetch(this.fetchUrl, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    })
      .then(res => res.json())
      .catch(error => ({ message: error }))

    if (response.error) {
      this.error(response)
    } else {
      this.success(response)
    }

    this.enableForm()
  }

  init() {
    // Watch for changes in form fields
    const inputs = this.form.querySelectorAll('input, textarea, select')
    Array.from(inputs).forEach(input => {
      input.addEventListener('change', () => {
        this.form.classList.add('form--dirty')
      })
    })

    // Track form abandonment
    window.addEventListener('unload', () => {
      if (this.form.classList.contains('form--dirty') && window.dataLayer && this.track) {
        window.dataLayer.push({
          event: `${this.track}-unfulfilled`,
        })
      }
    })
  }
}

const formInit = {
  // eslint-disable-next-line consistent-return
  init(selector = '.form') {
    const wrapperEl = document.querySelectorAll(selector)
    Array.from(wrapperEl).forEach(form => new Form(form))
  },
}

export default formInit
